import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar.jsx";
import Banner from "../Section/Banner/banner.jsx";
import About from "../Section/AR/AR.jsx";
import Promo from "../Section/Promo/promo.jsx";
import Logo from "../Section/Othercluster/othercluster.jsx";
import Produk from "../Section/Rumah/rumah.jsx";
import Fasilitas from "../Section/Fasilitas/fasilitas.jsx";
import Ruko from "../Section/Ruko/ruko.jsx";
import LogoR from "../Section/Logo Ruko/othercluster1.jsx";
import Surrounding from "../Section/Surrounding Area/surrounding.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/footer.jsx";

import ScrollToHashElement from "./ScrollToHashElement.js";

const home = () => {
  return (
    <div className="home">
      <ScrollToHashElement />
      <Navbar />
      <Banner />
      <About />
      <Promo />
      <Fasilitas />
      <Logo />
      <Produk />
      <LogoR />
      <Ruko />
      <Surrounding />
      <Lokasi />
      <Footer />
    </div>
  );
};

export default home;
